<template>
  <b-modal
    id="modal-create-ftp"
    ref="modal-ftp"
    :visible="visible"
    @hidden="hidden"
    :no-close-on-backdrop="loading"
    :no-close-on-esc="loading"
    centered
  >
    <template #modal-header>
      <h5 class="modal-title">ایجاد دسترسی FTP</h5>
    </template>
    <error-messages
      v-if="errorMessages.length > 0"
      :show="showError"
      :dismissible="true"
      @dismissed="dismissedError"
      :messages="errorMessages"
    />
    <b-form @submit.stop.prevent="createAccounts">
      <b-form-group>
        <label>نام کاربری</label>
        <b-form-input
          @update="usernameUpdated"
          type="text"
          :state="this.validationUserName"
          placeholder="حداقل 5 الی 16 کاراکتر شامل حروف کوچک، عدد و _"
          v-model="form.username.value"
        ></b-form-input>
        <b-form-invalid-feedback
          class="text-right"
          :state="this.validationUserName"
        >
          {{ form.username.error }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-checkbox v-model="form.readOnly" name="read-only-ftp-user">
        تنها دسترسی خوادنی داشته باشد.
      </b-form-checkbox>
    </b-form>
    <template #modal-footer>
      <b-button variant="secondary" @click="hidden" :disabled="loading">
        انصراف
      </b-button>
      <loading-btn
        :loading="loading"
        :disabled="okDisabled || loading"
        @click="createAccounts"
      >
        ایجاد دسترسی FTP
      </loading-btn>
    </template>
  </b-modal>
</template>

<script>
import { createFTP } from "@/services/service";
import LoadingBtn from "@/components/LoadingBtn/LoadingBtn.vue";
import ErrorMessages from "@/components/ErrorMessages/ErrorMessages.vue";

export default {
  components: { LoadingBtn, ErrorMessages },
  name: "CreateFtpModal",
  props: {
    visible: Boolean
  },
  data() {
    return {
      loading: false,
      form: {
        username: { value: "", error: "" },
        readOnly: false
      },
      validationUserName: null,
      okDisabled: true,
      showError: false,
      errorMessages: []
    };
  },
  methods: {
    reset: function() {
      this.form = {
        username: { value: "", error: "" },
        readOnly: false
      };
      this.showError = false;
      this.errorMessages = [];
      this.validationUserName = null;
    },
    dismissedError: function() {
      this.showError = false;
    },
    hidden: function() {
      this.reset();
      this.$emit("hidden");
    },
    createAccounts: async function() {
      this.loading = true;
      const [error, data] = await createFTP({
        ServiceId: this.$route.params.serviceId,
        Username: this.form.username.value,
        IsReadOnly: this.form.readOnly
      });
      if (error) {
        this.errorMessages = error;
        this.showError = true;
        this.loading = false;
      } else {
        if (data.apiStatus === 200) {
          this.$emit("createSuccess");
          this.hidden();
          this.loading = false;
        } else {
          this.errorMessages = [...data.apiErrors];
          this.showError = true;
          this.loading = false;
        }
      }
    },
    usernameUpdated: function(val) {
      const reg = /^[a-zA-Z0-9_]{5,16}$/;
      let newForm = { ...this.form };
      if (val === "") {
        newForm.username.error = "وارد کردن نام کاربری الزامیست.";
        this.validationUserName = false;
      } else if (!reg.test(val)) {
        newForm.username.error =
          "نام کاربری باید دارای 5 الی 16 کاراکتر طول؛ شامل حروف، اعداد و کاراکتر (_) در وسط باشد.";
        this.validationUserName = false;
      } else {
        newForm.username.error = "";
        this.validationUserName = true;
        newForm.username.value = val;
      }
      this.form = { ...newForm };
    }
  },
  updated() {
    if (this.validationUserName) {
      this.okDisabled = false;
    } else {
      this.okDisabled = true;
    }
  }
};
</script>

<style></style>
